import React from 'react'
import { styled } from '@mui/material/styles'
import { useRouter } from 'next/router'
import { Box, Container, Grid, Hidden } from '@mui/material/'
import { StyledDiv } from '@components/atoms/StyledDiv'
import { CatalogList } from '@components/organisms/CatalogList'
import { CategoryMainInfo } from '@components/organisms/CategoryMainInfo'
import { CatalogCategoryBreadcrumbs } from '@components/organisms/CatalogCategoryBreadcrumbs'
import { Pagination } from '@components/organisms/Pagination'
import { useGetFirstDepthCategoryQuery } from '@services/cloud/client'
import { CATALOG_PAGINATION_LENGTH } from '@services/coataz/constants'
import { CategoryList } from './CategoryList'
import { FirstDepthTreeView } from './FirstDepthTreeView'

const PREFIX = 'index'

const classes = {
  root: `${PREFIX}-root`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    marginBottom: theme.spacing(5),
    minHeight: '80vh',
  },
}))

export function FirstDepthCategory() {
  const router = useRouter()
  const { firstDepthCategoryId, page } = router.query
  const pageNumber = Number(page) ? Number(page) : 1

  const { data, error } = useGetFirstDepthCategoryQuery({
    variables: {
      args: {
        firstDepthCategoryId: firstDepthCategoryId as string,
      },
      catalogWhere: {
        skip: pageNumber,
      },
    },
  })

  if (error) {
    return <div>404 ページが存在しません</div>
  }

  const handlePageClick = (paginationData: { selected: number }) => {
    window.scrollTo(0, 0)
    router.push(`/catalogs/category/${firstDepthCategoryId}?page=${paginationData.selected + 1}`)
  }

  const pageCount =
    typeof data?.firstDepthCategory?.length === 'number'
      ? Math.ceil(data.firstDepthCategory.length / CATALOG_PAGINATION_LENGTH)
      : 0

  return (
    <Root>
      <Box className={classes.root}>
        <Container>
          <StyledDiv>
            <Box mt={1}>
              <CatalogCategoryBreadcrumbs
                category={{
                  firstDepth: {
                    categoryId: data?.firstDepthCategory?.categoryId as string,
                    name: data?.firstDepthCategory?.name as string,
                  },
                }}
              />
            </Box>
            <Box mt={3}>
              <Grid container={true}>
                <Hidden smDown={true}>
                  <Grid item sm={3}>
                    {data?.firstDepthCategory && (
                      <FirstDepthTreeView firstDepthCategory={data.firstDepthCategory} />
                    )}
                  </Grid>
                </Hidden>
                <Grid xs={12} sm={9}>
                  <CategoryMainInfo category={data?.firstDepthCategory} />
                  <CategoryList firstDepthCategory={data?.firstDepthCategory} />
                  <Box mt={5}>
                    <Grid container={true} spacing={1}>
                      {data?.firstDepthCategory?.catalogs &&
                        Array.isArray(data?.firstDepthCategory.catalogs) &&
                        data?.firstDepthCategory.catalogs.map((catalog) => (
                          <Grid key={catalog?.catalogId} item={true} xs={6} sm={4} md={3}>
                            <CatalogList catalog={catalog} />
                          </Grid>
                        ))}
                    </Grid>
                  </Box>
                  {pageCount > 0 && (
                    <Box pt={3} pb={3}>
                      <Pagination
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        handlePageClick={handlePageClick}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          </StyledDiv>
        </Container>
      </Box>
    </Root>
  )
}
